module.exports = __webpack_public_path__ + "img/sld_scb_36_t1_b1_green.3ae24a7e.svg";